module.exports = __webpack_public_path__ + "static/media/mail.3f5456a2.svg";